import React from 'react'
import { getFullFormattedDate } from '@components/Ackodrive/common/utils'
import { CardWrapper, Anchor, CardHeading, ModifiedDate, AuthorName, ShortDescription, Paragraph, CardImage } from './styles'

const Card = props => {
  const { image, title, url, modifiedDate, description, authorName } = props
  const imageUrl = typeof image === 'string' ? image : image?.url

  return (
    <CardWrapper id="card">
      <a href={url}>
        <Anchor>
          <CardImage defaultImage={typeof image !== 'string'} src={imageUrl} alt={title} />
          <CardHeading>{title}</CardHeading>
        </Anchor>
      </a>
      <ModifiedDate>
        <AuthorName>{authorName}</AuthorName> - Modified date: {getFullFormattedDate(modifiedDate)}
      </ModifiedDate>
      <ShortDescription>
        <Paragraph>{description}</Paragraph>
      </ShortDescription>
    </CardWrapper>
  )
}

export default Card
